import ArrowLeftIcon from '@elementor/icons/ArrowLeftIcon';
import Box from '@elementor/ui/Box';
import Dialog from '@elementor/ui/Dialog';
import DialogHeader from '@elementor/ui/DialogHeader';
import DialogTitle from '@elementor/ui/DialogTitle';
import IconButton from '@elementor/ui/IconButton';
import { styled } from '@elementor/ui/styles';
import { FocusTrap } from 'focus-trap-react';
import { INSTALL_MODAL_STEPS } from '@constants';
import { useInstallModalContext } from '@context/install-modal-context';
import { useAnalytics } from '@hooks/use-analytics';
import GoogleAnalyticsEvent, {
	EVENT_SECTIONS,
	EVENT_TYPES,
} from '@hooks/use-analytics/google-analytics-event';
import { GradientLogo } from '@images';
import { __ } from '@utils/i18n';
import GetFreeModalStepInstall from './steps/step-install';
import GetFreeModalStepSubscriptionForm from './steps/step-subscription-form';

const GetFreeModal = () => {
	const { sendEvent } = useAnalytics();
	const { isOpen, close, goToStep, step } = useInstallModalContext();

	const getContent = (activeStep) => {
		const screens = {
			[INSTALL_MODAL_STEPS.INSTALL]: <GetFreeModalStepInstall />,
			[INSTALL_MODAL_STEPS.SUBSCRIPTION_FORM]: (
				<GetFreeModalStepSubscriptionForm />
			),
		};

		return screens[activeStep];
	};

	const onClose = () => {
		close();

		sendEvent(
			new GoogleAnalyticsEvent()
				.setType(EVENT_TYPES.UI)
				.setSection(EVENT_SECTIONS.INSTALL_MODAL)
				.setElementName('close button')
				.setOutcome('closing the popup'),
		);
	};

	return (
		<StyledDialog
			open={isOpen}
			onClose={onClose}
			aria-labelledby="ea11y-install-dialog-title"
			aria-describedby="ea11y-install-dialog-subtitle"
		>
			<FocusTrap>
				<Box>
					<StyledDialogHeader
						logo={
							<>
								{INSTALL_MODAL_STEPS.INSTALL !== step && (
									<StyledBackButton
										aria-label={__('Go back to the previous screen')}
										onClick={() => goToStep(INSTALL_MODAL_STEPS.INSTALL)}
										size="small"
									>
										<ArrowLeftIcon />
									</StyledBackButton>
								)}

								<GradientLogo />
							</>
						}
						onClose={onClose}
					>
						<DialogTitle>{__('Ally Web Accessibility ')}</DialogTitle>
					</StyledDialogHeader>

					{getContent(step)}
				</Box>
			</FocusTrap>
		</StyledDialog>
	);
};

const StyledDialog = styled(Dialog)`
	z-index: 9999999;

	.MuiBackdrop-root {
		background: rgba(0, 0, 0, 0.7);
	}

	.MuiDialog-paper {
		max-width: none;
		width: 600px;
	}
`;

const StyledDialogHeader = styled(DialogHeader)`
	span:first-of-type {
		display: flex;
		justify-content: center;
		align-items: center;
	}
`;

const StyledBackButton = styled(IconButton)`
	margin-inline-end: 8px;
`;

export default GetFreeModal;
